import React from 'react';
import StayLocationtPageContainer from 'containers/StayLocationPageContainer';
import './styles.scss';

const StayLocationPage = () => (
   <div style={{backgroundColor: '#f4f4f4'}}><StayLocationtPageContainer hideFilter={false} /></div>  
);

export default StayLocationPage;
